import React, { useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  ParsingResultsProps,
} from "../types/JudgmentIntegrationTypes";
import judgementStore from "../stores/judgment-store";

export const ParsingResultsTable: React.FC<ParsingResultsProps> = () => {
  const dtEntries = useRef<DataTable>(null);
  const dtAliases = useRef<DataTable>(null);

  const getCivilErrorList = () => {
    const errorList = judgementStore.currentIntegration?.civilEntries?.filter(e => {return e.isProperlyFormatted === false})
    return errorList;
  }

  const getAliasErrorList = () => {
    const errorList = judgementStore.currentIntegration?.aliasEntries?.filter(e => {return e.isProperlyFormatted === false});
    return errorList;
  }

  const aliasFileTable = () => {
    if (judgementStore.currentIntegration?.aliasEntries?.length > 0) {
      return (
        <>
          <DataTable
            header={
              <div className="header">
                <div className="title">
                  Parsed rows from file:{" "}
                  {judgementStore.currentIntegration?.aliasFileName}
                </div>
              </div>
            }
            dataKey="ID"
            value={getAliasErrorList()}
            className="p-datatable-sm p-datatable-striped p-datatable-gridlines"
            emptyMessage="No Alias Errors"
            ref={dtAliases}
            rowHover
            paginator
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rowsPerPageOptions={[10, 25, 50, 100]}
            rows={10}
          >
            <Column
              header="Line Number"
              field="lineNumber"
              style={{ width: "3em" }}
              sortable
            />
            <Column
              header="Error"
              field="message"
              style={{ width: "20em" }}
              sortable
            />
          </DataTable>
        </>
      );
    }
    return false;
  };

  return (
    <>
      <DataTable
        header={
          <div className="header">
          <div className="title">
            Parsed rows from file:{" "}
            {judgementStore.currentIntegration?.civilEntriesFileName}
          </div>
        </div>
        }
        dataKey="ID"
        value={getCivilErrorList()}
        className="p-datatable-sm p-datatable-striped p-datatable-gridlines"
        emptyMessage="No Entry Errors"
        ref={dtEntries}
        rowHover
        paginator
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        rowsPerPageOptions={[10, 25, 50, 100]}
        rows={10}
      >
        <Column
          header="Line Number"
          field="lineNumber"
          style={{ width: "5em" }}
          sortable
        />
        <Column
          header="Error"
          field="message"
          style={{ width: "20em" }}
          sortable
        />
      </DataTable>
      <hr />
      {aliasFileTable()}
    </>
  );
};
